<template>
    <div id="the-pier-wrapper" class="portfolio-page">
        <div id="the-pier">
            <PortfolioHeader 
                :pageName="pageName"
                :disciplines="disciplines" 
                :services="services"
                :pageLink="pageLink"
                :linkName="linkName"
            />
            <section class="">
                <img src="/img/portfolio/pier/pier-color-theme.jpg" alt="The Pier - Color Theme" class="w-100 d-block">
            </section>
            <section class="">
                <img src="/img/portfolio/pier/the-pier-drinks.jpg" alt="The Pier" class="w-100 d-block">
            </section>
            <section>
                <FullWidthSlider 
                :slides="firstSliderItems"
                :styles="firstSliderStyles"/>
            </section>
            <section 
            class="cta-section py-5" 
            style="">
                <b-row>
                    <b-col lg="6">
                        <div class="bg-black text-white py-60 px-5 max-w-320 mx-auto">
                            <div style="height: 4px" class="bg-white w-100"></div>
                            <p class=" py-50 mb-0">
                                <span class="gotham-bold">
                                    RADIO INITIATIVES
                                </span>
                                <br>
                                Our secret weapon in this branding study was radio. Though many see radio advertising as obsolete, we believe it's a lost art. If you've ever had a song stuck in your head, you know exactly how powerful a simple tune can be. 1063 built several melodies around the phrase "Here's to The Pier" – creating radio ads so catchy that we still sing them in the office today.
                            </p>
                            <div class="d-flex justify-content-around">
                                <div class="play-pause text-center radio">
                                    <p class="text-center">
                                        RADIO 1
                                    </p>
                                    <img src="/img/pause-btn-transparent.png" alt="Play" class="w-100 max-w-80 mx-auto mb-4 pause-btn" role="button" style="display: none">
                                    <img src="/img/play-btn-transparent.png" alt="Play" class="w-100 max-w-80 mx-auto mb-4 play-btn" role="button">
                                </div>
                                <!--  -->
                                <div class="play-pause text-center song">
                                    <p class="text-center">
                                        RADIO 2
                                    </p>
                                    <img src="/img/pause-btn-transparent.png" alt="Play" class="w-100 max-w-80 mx-auto mb-4 song-pause-btn" role="button" style="display: none">
                                    <img src="/img/play-btn-transparent.png" alt="Play" class="w-100 max-w-80 mx-auto mb-4 song-play-btn" role="button">
                                </div>
                            </div>
                            
                            <audio ref="pierAudio">
                                <source src="/audio/The-Pier-Apologies-to-TO-Mike-McCurlie.mp3" type="audio/mpeg" class="d-block w-100">
                                Your browser does not support the audio element.
                            </audio>
                            <audio ref="pierSongAudio">
                                <source src="/audio/the-pier-song.mp3" type="audio/mpeg" class="d-block w-100">
                                Your browser does not support the audio element.
                            </audio>
                            <div style="height: 4px" class="bg-white w-100"></div>
                        </div>
                    </b-col>
                    <b-col lg="6"></b-col>
                </b-row>
            </section>
            <section>
                <ImageAndTextPortfolio 
                    :imageAndTextContent="imageAndTextContent"
                />
            </section>
            <section class="">
                <img src="/img/portfolio/pier/pier-outdoor-sign.jpg" alt="The Pier" class="w-100 d-block">
            </section>
            <section>
            <FullWidthSlider2 
                :slides="secondSliderItems"
                :styles="secondSliderStyles"/>
            </section>
            <section class="conclusion">
                <b-container class="next-project stipple-bg py-5" fluid>
                    <NextProject :nextProject="nextProject"/>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    head: {
      title: "Guidelines Advertising Inc - 1063 Eglinton Ave",
      meta: [
        {
            hid: "description",
            content:
            "Guidelines Advertising is a full-service real estate marketing company with over 35 years experience in Toronto, Ontario, Canada."
        },
        { 
            hid: 'keywords', 
            name: 'keywords', 
            content: 'Toronto,Real estate décor consulting Toronto, real estate, marketing, toronto, branding, social media, web development, interior design, print, advertising, content marketing, eglinton'
        }
      ]
    },
    data() {
        return {
            audioPlaying: false,
            scrollSmoother_thePier: null,
            textAnimation_thePier: null,
            fadeInUpElement_thePier: null,
            disciplines: [
                {
                    name: "real estate development"
                }
            ],
            services: [
                {
                    name: "project identity creation"
                },
                {
                    name: "print ad"
                },
                {
                    name: "direct mail design"
                },
                {
                    name: "website design & development"
                },
                {
                    name: "media planning"
                },
                {
                    name: "signage design"
                },
                {
                    name: "radio & web video advertising"
                }
            ],
            pageName: "The Pier",
            pageLink: "",
            linkName: "",
            firstSliderStyles: {
                bgColor: '#d7b140',
                textColor: '#000',
                sliderClass: 'slider-dots-black',
                imgOnLeftSide: true,
                heading: "GIVE AWAYS",
                desc: "We took a direct approach to marketing one of the most transformative developments in Hamilton's history. The Pier would change the very fabric of Hamilton's waterfront district, so engaging with community members across the city was our main mission. In-depth market research and personal communication with Hamiltonians proved giveaways to be an ideal tool for building awareness, interest, and excitement.",
                subheading: ''
            },
            firstSliderItems: [
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-pier-apologies.jpg",
                    alt: "The Pier - Gift Bag"
                },
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-pier-shirt.jpg",
                    alt: "The Pier - TSHirt"
                },
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-pier-table.jpg",
                    alt: "The Pier - Coaster"
                }
            ],
            secondSliderStyles: {
                bgColor: '#202620',
                textBackgroundImg: 'stipple-bg',
                imgOnLeftSide: false,
                imgPadding: false,
                textColor: 'text-black',
                sliderClass: 'slider-dots-black',
                heading: "GUERILLA MARKETING CAMPAIGN",
                desc: "Flyers, murals, and live signage created a relatable campaign rooted in community sentiment. The Pier's scale and importance rival some of Toronto's most iconic districts and truly transform Hamilton, meaning community support was integral to its success. No longer would this city play second fiddle to Toronto, and a 'boots on the ground' marketing method would turn this idea into something far more than a mere ambition. It would become a significant community movement. ",
                subheading: ''
            },
            secondSliderItems: [
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-pier-signage.jpg",
                    alt: "The Pier - Outdoor Signage"
                },
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-pier-hamilton.jpg",
                    alt: "The Pier - Outdoor Signage"
                },
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-pier-signage-2.jpg",
                    alt: "The Pier - Outdoor Signage"
                },
            ],
            imageAndTextContent: {
                imgOnLeftSide: false,
                bgColor: '#202620',
                bgImageClass: "",
                textColor: "#fff",
                img: "/img/portfolio/pier/the-pier-guerilla-marketing.jpg",
                alt: "Pier House Sign",
                heading: "GUERILLA MARKETING",
                desc: "Guerilla Marketing, as many understand it, means advertising exclusively in zoos, wildlife enclosures, and aquariums. For such a landmark new development though, we used a different approach to addressing Hamilton's proverbial elephant in the room. "
            },
            nextProject: {
                link: "/portfolio/southport",
                name: "Southport"
            }
            
        }
    },
    components: {
        PortfolioHeader: () => import('@/components/PortfolioHeader'),
        FullWidthSlider: () => import('@/components/FullWidthSlider'),
        FullWidthSlider2: () => import('@/components/FullWidthSlider2'),
        ImageAndTextPortfolio: () => import('@/components/ImageAndTextPortfolio'),
        Transition1063: () => import('@/components/Transition1063'),
        NextProject: () => import('@/components/NextProject'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_thePier();
            // 
            this.initImgElReveal_thePier();
            this.initTextReveal_thePier();

            var playBtn = document.querySelector('.play-btn');
            var pauseBtn = document.querySelector('.pause-btn');

            playBtn.addEventListener('click', () => {
                this.$refs.pierAudio.play();
                this.audioPlaying = !this.audioPlaying;
                playBtn.style.display = 'none';
                pauseBtn.style.display = 'block';
            })

            pauseBtn.addEventListener('click', () => {
                this.$refs.pierAudio.pause();
                this.audioPlaying = !this.audioPlaying;
                playBtn.style.display = 'block';
                pauseBtn.style.display = 'none';
            })

            // 

            var songPlayBtn = document.querySelector('.song-play-btn');
            var songPauseBtn = document.querySelector('.song-pause-btn');

            songPlayBtn.addEventListener('click', () => {
                this.$refs.pierSongAudio.play();
                songPlayBtn.style.display = 'none';
                songPauseBtn.style.display = 'block';
            })

            songPauseBtn.addEventListener('click', () => {
                this.$refs.pierSongAudio.pause();
                songPlayBtn.style.display = 'block';
                songPauseBtn.style.display = 'none';
            })

            // this.$refs.castlemileVideo.addEventListener('playing', () => {
            //     playBtn.style.display = 'none'
            // })

            // this.$refs.castlemileVideo.addEventListener('pause', () => {
            //     playBtn.style.display = 'block'
            // })

        }, 500)
    },
    methods: {
        initscrollSmoother_thePier() {
            this.scrollSmoother_thePier = ScrollSmoother.create({
                wrapper: '#the-pier-wrapper',
                content: "#the-pier",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_thePier.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_thePier() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_thePier = this.fadeInUpElement_thePier;
                fadeInUpElement_thePier = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_thePier.set(container, { autoAlpha: 1 });
                fadeInUpElement_thePier.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_thePier() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_thePier = this.textAnimation_thePier;
                textAnimation_thePier = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words,lines",
                    wordsClass: "words",
                    linesClass: "lines"
                });
                textAnimation_thePier.set(container, { autoAlpha: 1 });
                textAnimation_thePier.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_thePier.kill();
        }, 500)
    }
}
</script>

<style lang="scss">
@import '@/assets/styles/variables';

.portfolio-page {
    .cta-section {
        background-image: url('/img/portfolio/pier/the-pier-radio.jpg');
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 100%;
    }

    .pier-background {
        background: url('/img/portfolio/pier/pier-color-theme.jpg') no-repeat center center; 
        background-size: cover;
    }
}


</style>